'use strict';

var React = require('react');
var _ = require('lodash');
var TextInput = require('../Common/TextInput.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var ContentService = require('../../services/ContentService');
var HOME_NUMBER = 'homeNumber';
var WORK_NUMBER = 'workNumber';

var TelephoneNumbers = React.createClass({
    getDefaultProps: function () {
        return {
            index: '',
            section: '',
            forBusiness: false,
            showOnlyMobileNumber: false,
            addedPhoneNumber: undefined,
            hideWhyWeAskMobileText: false,
            isBusiness: false
        };
    },
    initialState: function() {
      var phoneNumberData, workNumberShown, homeData = { id: HOME_NUMBER, name: 'Home phone number', isHidden: true, isDisabled: Boolean(this.props.homeNumber) };
      if (this.props.forBusiness) {
          phoneNumberData = [homeData];
          workNumberShown = true;
      }
      else {
          phoneNumberData = [homeData, { id: WORK_NUMBER, name: 'Work phone number', isHidden: true, isDisabled: Boolean(this.props.workNumber) }];
          workNumberShown = Boolean(this.props.workNumber);
      }
      return {
          showWorkHomePhone: { homeNumber: this.props.homeNumber, workNumber: this.props.workNumber },
          disableAddPhoneNumberChoices: Boolean(this.props.homeNumber) && workNumberShown,
          addNewPhoneNumberData: phoneNumberData
      };
    },
    getInitialState: function () {
      return this.initialState();
    },

    componentWillReceiveProps: function (nextProps) {
        if (!this.state.showWorkHomePhone.homeNumber && nextProps.homeNumber) {
            this._showHideNumber('homeNumber', true);
        }
        if (!this.state.showWorkHomePhone.workNumber && nextProps.workNumber) {
            this._showHideNumber('workNumber', true);
        }
    },


    _showHideNumber: function (id, value) {
        //add work / home phone textboxes
        var updateShowWorkHomePhone = _.clone(this.state.showWorkHomePhone);
        updateShowWorkHomePhone[id] = value;
        this.setState({ showWorkHomePhone: updateShowWorkHomePhone });

        //update the list of add phone choices
        var updateAddNewPhoneNumberData = _.clone(this.state.addNewPhoneNumberData);
        var addNewPhone = _.find(updateAddNewPhoneNumberData, function (o) { return o.id === id });
        if (addNewPhone) {
            addNewPhone.isDisabled = value;
        }
        this.setState({ addNewPhoneNumberData: updateAddNewPhoneNumberData });

        //update disable/enable the add button
        if (this.props.forBusiness) {
            this.setState({ disableAddPhoneNumberChoices: updateAddNewPhoneNumberData[0].isDisabled });
        }
        else {
            this.setState({ disableAddPhoneNumberChoices: updateAddNewPhoneNumberData[0].isDisabled && updateAddNewPhoneNumberData[1].isDisabled });  //when both work and home phone have been added, disable the add button
        }

        this.setState({addedPhoneNumber: id});
    },

    _onNewNumberAdded: function (event) {
        this._showHideNumber(event.target.value, true);
    },

    _onTelephoneNumberRemoved: function (model) {
        this._showHideNumber(model, false);

        //clear value in that phone type
        this.props.onContactDetailsChange({ target: { id: this.props.section + model + this.props.index, model: model, value: '' } }); //after remove clear the value
    },

    componentDidUpdate: function(prevProps) {
      if (this.state.addedPhoneNumber){
        this.refs[this.state.addedPhoneNumber].inputFocus();
        this.setState({addedPhoneNumber: undefined});
      }
      if (this.props.id !== prevProps.id){
        this.setState(this.initialState());
      }
    },

    _renderMobileNumber: function () {
        var ydContent = ContentService.getContent().yourDetails;
        var contextualMessage = this.props.isBusiness ? ydContent.businessMobileCopy : ydContent.mobileCopy;
        return (<TextInput label="Mobile number"
                           id={this.props.section + 'mobileNumber' + this.props.index}
                           customClass="contact-number"
                           value={this.props.mobileNumber}
                           onBlur={this.props.onContactDetailsChange}
                           errorList={this.props.errorList}
                           model="mobileNumber"
                           contextualMessage={(!this.props.mobileNumber || this.props.hideWhyWeAskMobileText) ? null : contextualMessage } 
                           isDisabled={this.props.mobileNumberReadonly}/>);

    },
    _renderHomeNumber: function () {
        return (<TextInput label="Home phone number"
                           id={this.props.section + 'homeNumber' + this.props.index}
                           ref={HOME_NUMBER}
                           customClass="contact-number"
                           value={this.props.homeNumber}
                           onBlur={this.props.onContactDetailsChange}
                           errorList={this.props.errorList}
                           removable={!this.props.homeNumberReadonly}
                           onRemoving={this._onTelephoneNumberRemoved.bind(this, 'homeNumber')}
                           mandatory={this.props.homeNumberReadonly}
                           model="homeNumber"
                           isHidden={!this.state.showWorkHomePhone.homeNumber} 
                           isDisabled={this.props.homeNumberReadonly} />);
    },
    _renderWorkNumber: function (isDefault) {
        return (<TextInput label="Work phone number"
                           ref={WORK_NUMBER}
                           id={this.props.section + 'workNumber' + this.props.index}
                           customClass="contact-number"
                           value={this.props.workNumber}
                           onBlur={this.props.onContactDetailsChange}
                           errorList={this.props.errorList}
                           removable={!this.props.workNumberReadonly && !Boolean(isDefault)}
                           onRemoving={this._onTelephoneNumberRemoved.bind(this, 'workNumber')}
                           mandatory={this.props.workNumberReadonly}
                           model="workNumber"
                           isHidden={(!isDefault) ? !this.state.showWorkHomePhone.workNumber : false} 
                           isDisabled={this.props.workNumberReadonly}/>);
    },
    _renderAddPhoneNumber: function () {
        return (<RadioInput id={this.props.section + 'addPhoneNumberChoices' + this.props.index}
                            customClass="add-contact-number"
                            data={this.state.addNewPhoneNumberData}
                            moreButtonText="+ Add another number"
                            onChange={this._onNewNumberAdded}
                            model="addPhoneNumberChoices"
                            isHidden={this.state.disableAddPhoneNumberChoices} />);
    },
    render: function () {
        if (this.props.forBusiness) {
            return (
                <div key={'telephoneNumbers' + this.props.id}>
                    {this._renderWorkNumber(true)}
                    {this._renderHomeNumber()}
                    {this._renderAddPhoneNumber()}
                </div>
            );
        } else {
            if (this.props.showOnlyMobileNumber){
              return (
                  <div key={'telephoneNumbers' + this.props.id}>
                      {this._renderMobileNumber()}
                  </div>
              );
            }
            else{
              return (
                  <div key={'telephoneNumbers' + this.props.id}>
                      {this._renderMobileNumber()}
                      {this._renderHomeNumber()}
                      {this._renderWorkNumber()}
                      {this._renderAddPhoneNumber()}
                  </div>
              );
            }
        }

    }
});

module.exports = TelephoneNumbers;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/TelephoneNumbers.jsx